import React, { useEffect } from 'react';
import Carousel from 'react-elastic-carousel';
import './intro.css';
import { INTRO_CIRCLES, INTRO_PAGE_LOGO } from '../../constants/urls';
import {
  Container,
  Circles,
  IntroDiv,
  IntroHeader,
  LoginButton,
  Logo,
  IntroText,
} from './styles';
import { redirectToSSOWithParams } from '../../utils/auth';
import { track } from '../../analytics/analytics';
import { EventIDs } from '../../analytics/events';

const Intro = () => {
  useEffect(() => {
    track(EventIDs.INTRO_PAGE);
  }, []);

  const SigninCLickHandler = () => {
    track(EventIDs.SIGN_IN_CLICK);
    redirectToSSOWithParams();
  };

  return (
    <Container>
      <Logo src={INTRO_PAGE_LOGO} alt="" />
      <IntroDiv>
        <IntroHeader>Get started!</IntroHeader>
        <Carousel showArrows={false} enableAutoPlay={false} isRTL={false}>
          <IntroText>Get up and running in 3 minutes</IntroText>
          <IntroText>Zero downtime, uninterrupted e-Invoicing</IntroText>
          <IntroText>Affordable and state-of-the-art</IntroText>
        </Carousel>
        <LoginButton onClick={SigninCLickHandler} type="button">
          Sign in
        </LoginButton>
      </IntroDiv>
      <Circles src={INTRO_CIRCLES} alt="" />
    </Container>
  );
};

export default Intro;
